import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserProfile } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';
import { TipService } from 'app/tips';

import * as moment from 'moment';

import {NavService} from 'shared/nav/nav.service';
import { DefaultMenuPage } from '../default-menu-page/default-menu-page';
import { CModuleService } from 'app/cmodule/services/cmodule.service';
import { CModule } from 'app/cmodule';

@Component({
  selector: 'knowhow-page',
  templateUrl: 'knowhow-page.html',
  styleUrls: ['knowhow-page.scss'],
})
export class KnowHowPage extends DefaultMenuPage implements OnInit {

  public hasCModules: boolean = false;
  public hasContents: boolean = false;

  public lineY = '';

  private _podcastButtonAges: Array<Date> = [];
  private _podcastLastViewedAt: moment.Moment = null;

  constructor(
    public navService: NavService,
    private userService: UserService,
    private translateService: TranslateService,
    private tipService: TipService,
    private cmodulesService: CModuleService,
  ) {
    super(navService, translateService);
    if ( navService.get('lineY') !== undefined ) {
      this.lineY = (navService.get('lineY')-56-24)+'px'; // TODO: Header-Höhe und halbe Itemhöhe
      // console.log("## "+navService.get('lineY')+'px');
    }
    this.userService.getUserProfile('full').subscribe(this.onProfileLoaded.bind(this));
    this.cmodulesService.getCModules('count').subscribe((cmodules: Array<CModule>) => {
      this.hasCModules = cmodules.length > 0;
    });
    
  }

  public ngOnInit(): void {
    this.loadPodcastButtonAges();
  }

  private loadPodcastButtonAges(): void {
    this.tipService.getPodcastButtonAges('podcast')
      .subscribe((ages) => { this._podcastButtonAges = ages; });
  }

  public get newContentCount(): number {
    return this.userService.getNewContentCount();
  }

  public get newPodcastCount(): number {
    if (this._podcastLastViewedAt !== null) {
      return this._podcastButtonAges.filter((age) => moment(age).isAfter(this._podcastLastViewedAt)).length;
    }
    return 0;
  }

  public showCModulePage(): void {
    this.navService.push('cmodule');
  }

  public showContentsPage(): void {
    this.navService.push('content');
  }

  public showPodcastPage(): void {
    this.navService.push('knowledge/podcast');
  }

  public showVideosPage(): void {
    this.navService.push('knowledge/video');
  }

  public showTipsPage(): void {
    this.translateService.get('TIPS.TITLE').subscribe((title) => {
      this.tipService.getRootQuestion().subscribe((question) => {
        this.navService.push('tips/' + question._id, {
          question: question,
          overrideTitle: title,
          isInReflectionMode: false,
        });
      });
    });
  }

  private onProfileLoaded(profile: UserProfile): void {
    this.hasContents = profile.contents && profile.contents.some((userContent) => userContent.state === 0 || userContent.state >= 5);
    if (profile.podcastLastViewedAt) {
      this._podcastLastViewedAt = moment(profile.podcastLastViewedAt);
    }
  }

}
